import React from 'react';
import UFOSegment from '@atlaskit/react-ufo/segment';
import { CardWithMediaClient } from './cardWithMediaClient';
var CardSync = function CardSync(props) {
  return /*#__PURE__*/React.createElement(UFOSegment, {
    name: "media-card-sync",
    mode: "list"
  }, /*#__PURE__*/React.createElement(CardWithMediaClient, props));
};
export default CardSync;